import script from "./ComputeTaskDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ComputeTaskDetail.vue?vue&type=script&lang=ts&setup=true"

import "./ComputeTaskDetail.vue?vue&type=style&index=0&id=d5e6a9e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5e6a9e2"]])

export default __exports__